import { atom } from "jotai";
import { AxiosInstance } from "axios";
import useApi, {
	ApiStatus,
	ApiActions,
	emptyApiState,
} from "src/hooks/api/utils/useApi";
import { ApiTenant, ApiTenantSettings } from "src/api/types";
import { getCurrentDomainName } from "src/lib/domain";
// import { useNavigate } from "react-router-dom";
// TODO: Enable use navigate

interface TenantApiActions extends ApiActions {
	current: () => Promise<any>;
	linkCurrent: () => Promise<any>;
}

type State = {
	tenant: ApiTenant;
	settings: ApiTenantSettings;
	status: ApiStatus;
	actions: TenantApiActions;
	api: AxiosInstance;
};

const tenantAtom: any = atom(emptyApiState);

function useTenant(): State {
	// const navigate = useNavigate();
	const { state, actions, api } = useApi(tenantAtom, {
		baseUrl: "/tenant",
	});

	const getCurrent = async () => {
		const host = getCurrentDomainName();
		try {
			return await actions.get("current", {
				host,
			});
		} catch (error: any) {
			console.log("Error ->", error);
			actions.set({ status: "error" });
		}
	};

	const linkCurrent = async () => {
		actions.set((state: any) => ({
			...state,
			status: "linking",
		}));
		try {
			const tenant = await api
				.post("current/link", {})
				.then(({ data }) => data?.data);
			actions.set((state: any) => ({
				...state,
				status: "idle",
				data: tenant,
			}));
			if (tenant?.has_access) {
				// navigate("/dashboard");
			}
			return tenant;
		} catch (error: any) {
			console.log("Error ->", error);
			actions.set({ status: "error" });
		}
	};

	return {
		tenant: state?.data || {},
		settings: state?.data?.settings || {},
		status: state.status,
		actions: {
			...actions,
			current: getCurrent,
			linkCurrent,
		},
		api,
	};
}

export default useTenant;
